import React from 'react';
import { CardDeck, Card, Button, Container } from 'react-bootstrap';
import b0f from '../upload/b0f.jpg';
import pp2j from '../upload/pp2j.jpg';
import cc  from '../upload/cc.jpg';
import b60 from '../upload/b60.jpg';
import j060 from '../upload/060.jpg';
import e3e6 from '../upload/3e6.jpg';
import a6a2 from '../upload/6a2.jpg';
import f17 from '../upload/17f.jpg';
import cfc from '../upload/cfc.jpg';
import akvakulturaph from '../upload/akvakulturaph.jpg';
import b02b from '../upload/02b.jpg';
import avtophoto from '../upload/avtomatizaciyaph.jpg';
import b96 from '../upload/b96.jpg';
import a468 from '../upload/468.jpg';
import vpribory from '../upload/vpribory.jpg';
import a147 from '../upload/147.jpg';
import a3f8 from '../upload/3f8.jpg';
import a4e9 from '../upload/4e9.jpg';
import a7ae from '../upload/7ae.jpg';
import a949 from '../upload/949.jpg';
import b06 from '../upload/b06.jpg';
import a398 from '../upload/398.jpg';
import a3fb from '../upload/3fb.jpg';
import a465 from '../upload/465.jpg';
import a2d2 from '../upload/2d2.jpg';
import add8 from '../upload/dd8.jpg';
import e1b from '../upload/e1b.jpg';
import f09 from '../upload/f09.jpg';
import a36f from '../upload/36f.jpg';
import a2a2 from '../upload/2a2.jpg';
import a13c from '../upload/13c.jpg';
import a36d from '../upload/36d.jpg';
import a1cc from '../upload/1cc.jpg';
import a45d from '../upload/45d.jpg';
import a6f9 from '../upload/6f9.jpg';
import pp from '../files/proizvodstvennaya_programma.pdf';
import pp2 from '../files/pishevoi_promyshlennosti.pdf';
import odmp from '../files/oborudovanie_dlya_mp.pdf';
import odpp from '../files/oborudovanie_dlya_pp.pdf';
import fb from '../files/farm_bio.pdf';
import pro_p from '../files/pro_pechi.pdf';
import gidro_os from '../files/gidro_os.pdf';
import akva from '../files/akvakultura.pdf';
import aquis from '../files/aquis.pdf';
import avtomat from '../files/avtomatizaciya.pdf';
import davlenie from '../files/davlenie.pdf';
import dicon from '../files/dicon.pdf';
import dtrans from '../files/dtrans.pdf';
import ecoline from '../files/ecoline.pdf';
import electro_azh from '../files/electro_azh.pdf';
import extherm from '../files/extherm.pdf';
import fbjumo from '../files/fbjumo.pdf';
import frost from '../files/frost.pdf';
import iip from '../files/iip.pdf';
import iz_ur from '../files/izmerenie_ur.pdf';
import jwtrans from '../files/jumo_wtrans.pdf';
import maera from '../files/maera.pdf';
import midas from '../files/midas.pdf';
import midas_s21 from '../files/midas_s21.pdf';
import mtron from '../files/mtron.pdf';
import odhp from '../files/odhp.pdf';
import quantrol from '../files/quantrol.pdf';
import reg_pri from '../files/reg_pri.pdf';
import samopistcy from '../files/samopistcy.pdf';
import sredstva_it from '../files/sredstva_it.pdf';
import stb_stx from '../files/stb_stx.pdf';
import tech_arp from '../files/tech_arp.pdf';
import vlazhnost from '../files/vlazhnost.pdf';
import vzryvobezopasnye_pribory from '../files/vzryvobezopasnye_pribory.pdf';
import wtrans from '../files/wtrans.pdf';
import ScrollToTop from "react-scroll-to-top";

function Catalog(props) {
    return(
        <div style={{ margin: "auto", padding: "0", textAlign: "center", color: "#233048"}}>
            <ScrollToTop smooth />
            <h1 >Проспекты</h1>
            <Container fluid={false} style={{marginTop:"2rem",marginBottom:"2rem"}}>
            <CardDeck>
               
                    <Card style={{ borderColor: "rgba(0,0,0,0)",opacity: "1"}}>
                    <Card.Body>
                            <a href={pp} target="_blank" rel="noopener noreferrer">
                     <Card.Img  variant="top" src={b0f} style={{ height: 280, width: 200 }}/>
                        <Card.Text>
                                   
                                        <ul className="list-unstyled">
                                            <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Производственная программа (Датчики и решения по автоматизации)
                                       </Button>
                                            </li>
                                            <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                            </li>
                                        </ul>
                                     
                                   </Card.Text>
                            </a>
                           </Card.Body>
                        </Card>
                
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={pp2} target="_blank" rel="noopener noreferrer">
                            <Card.Img variant="top" src={pp2j} style={{ height: 280, width: 200 }} />
                            
                            <Card.Text>
                                
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Оборудование для пищевой промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>
                                    
                            </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={odmp} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={cc} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            Оборудование для молочной промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
            </CardDeck>
              {/* 2*/}
                <CardDeck>
           <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={odpp} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={b60} style={{ height: 280, width: 200}} />
                                <Card.Text>
                                        <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Оборудование для пивоваренной промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={fb} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={j060} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Оборудование для пищевой промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={pro_p} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={e3e6} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Оборудование для пищевой промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 3*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={gidro_os} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a6a2} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Гидротехническое оборудование и системы очистки сточных вод
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={tech_arp} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={f17} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Техника автоматического регулирования для практиков
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={avtomat} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={avtophoto} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Автоматизация (Инновационные решения для самых высоких требований)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 4*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={mtron} target="_blank" rel="noopener noreferrer">
                                
                                <Card.Img variant="top" src={cfc} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             JUMO mTRON T (Автоматизированная система
                                    управления JUMO mTRON T)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={akva} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={akvakulturaph} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            Аквакультура (Инновационные решения для Вашего успеха)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={odhp} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={b02b} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             	Оборудование для химической промышленности
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 5*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={iz_ur} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={b96} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            Измерение уровня (Гидростатические зонды уровня жидкости)
                                           </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={vlazhnost} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a468} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            Влажность (Инновационные решения для самых требовательных клиентов)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={vzryvobezopasnye_pribory} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={vpribory} style={{ height: 280, width: 200 }} />
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Взрывобезопасные приборы 
                                             (Оборудование для взрывоопасных зон согласно Европейским директивам 94/9/ EG)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 6*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={fbjumo} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a147} style={{ height: 280, width: 200 }} />
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             Функциональная безопасность с JUMO safetyM
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={reg_pri} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a3f8} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             	Регулирующие приборы
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={electro_azh} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a4e9} style={{ height: 280, width: 200 }} />

                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             	Электрохимический анализ жидких сред
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
           
           
            {/* 7*/}
            <CardDeck>
                <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                    <Card.Body>
                        <a href={sredstva_it} target="_blank" rel="noopener noreferrer">
                            <Card.Img variant="top" src={a7ae} style={{ height: 280, width: 200 }} />
                            <Card.Text>
                                <ul className="list-unstyled">
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                        }}>
                                            <i className="fas fa-download" />
                                             Средства измерения температуры
                                       </Button>
                                    </li>
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                        }} >
                                            <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                    </li>
                                </ul>

                            </Card.Text>
                        </a>
                    </Card.Body>
                </Card>

                <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                    <Card.Body>
                        <a href={davlenie} target="_blank" rel="noopener noreferrer">
                            <Card.Img variant="top" src={a949} style={{ height: 280, width: 200 }} />

                            <Card.Text>

                                <ul className="list-unstyled">
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                        }}>
                                            <i className="fas fa-download" />
                                             Давление
                                       </Button>
                                    </li>
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                        }} >
                                            <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                    </li>
                                </ul>

                            </Card.Text>
                        </a>
                    </Card.Body>
                </Card>
                <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                    <Card.Body>
                        <a href={wtrans} target="_blank" rel="noopener noreferrer">
                            <Card.Img variant="top" src={b06} style={{ height: 280, width: 200 }} />
                                
                            <Card.Text>

                                <ul className="list-unstyled">
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                        }}>
                                            <i className="fas fa-download" />
                                             	JUMO Wtrans p (Преобразователь давления я беспроводной передачей данных)
                                       </Button>
                                    </li>
                                    <li>
                                        <Button style={{
                                            color: "#233048", border: "0",
                                            backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                        }} >
                                            <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                    </li>
                                </ul>

                            </Card.Text>
                        </a>
                    </Card.Body>
                </Card>
            </CardDeck>
                {/* 8*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={ecoline} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a398} style={{ height: 280, width: 200 }} />
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                           JUMO ecoLine NTU
                                            (Оптический датчик для измерения мутности с индикатором / регулятором JUMO AQUIS 500 RS)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={stb_stx} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a3fb} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             JUMO safetyM STB/STW Ex (Предохранительный ограничитель температуры/реле с ATEX-допуском)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={midas} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a465} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             		JUMO MIDAS S19 R 
                                                     (Преобразователь давления для использования на железнодорожном транспорте)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 9*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={frost} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a2d2} style={{ height: 280, width: 200 }} />
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                           JUMO frostTHERM-AT/-DR (Термостат защиты от замерзания)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={extherm} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={add8} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             	JUMO exTHERM-AT (Взрывозащищенный термостат поверхностного монтажа)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={dtrans} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={e1b} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             		JUMO dTRANS T05 (Программируемый двухпроводный преобразователь с USB-интерфейсом)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 10*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={dicon} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={f09} style={{ height: 280, width: 200 }} />
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                           JUMO DICON touch (Двухканальный программный регулятор процесса с
                                    функцией регистрации и сенсорным экраном )
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={maera} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a36f} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                               JUMO MAERA S29 SW ( Высокопрочный зонд уровня из титана)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={midas_s21} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a2a2} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            JUMO MIDAS S21 Ex (Преобразователь давления для взрывоопасных зон)

                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 11*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={jwtrans} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a13c} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                            Серия JUMO Wtrans (Беспроводной системный комплекс измерения температуры)
                                     
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={samopistcy} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a36d} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                Самописцы
                                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={quantrol} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a1cc} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                             		Quantrol LC100 / LC200 / LC300 (Универсальный ПИД-регулятор)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                </CardDeck>
                {/* 12*/}
                <CardDeck>
                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={aquis} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a45d} style={{ height: 280, width: 200 }} />
                                
                                <Card.Text>
                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                    JUMO AQUIS touch S/P (Модульные многоканальные измерительные
                                    преобразователи для анализа параметров жидкости
                                    с интегрированным регулятором и самописцем)
                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderColor: "rgba(0,0,0,0)", opacity: "1" }}>
                        <Card.Body>
                            <a href={iip} target="_blank" rel="noopener noreferrer">
                                <Card.Img variant="top" src={a6f9} style={{ height: 280, width: 200 }} />
                                <Card.Text>

                                    <ul className="list-unstyled">
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.9rem"
                                            }}>
                                                <i className="fas fa-download" />
                                              	Искробезопасный источник питания (с гальванической развязкой
                                    и усилением входного сигнала)
                                                       </Button>
                                        </li>
                                        <li>
                                            <Button style={{
                                                color: "#233048", border: "0",
                                                backgroundColor: "rgba(0,0,0,0)", opacity: "1", fontSize: "0.8rem"
                                            }} >
                                                <i className="fas fa-download" />
                                       Скачать
                                       </Button>
                                        </li>
                                    </ul>

                                </Card.Text>
                            </a>
                        </Card.Body>
                    </Card>
                    
                </CardDeck>
            </Container>
        </div>
    );
}

export default Catalog;